// extracted by mini-css-extract-plugin
export default {"wrapper":"carousel-tab-module--wrapper--20f32","selected":"carousel-tab-module--selected--8c02a"};